// extracted by mini-css-extract-plugin
export default {"row":"SignIn_row__ZFQ9M","col":"SignIn_col__TmmWa","reset-pw":"SignIn_reset-pw__5DKBv"};